

















import Vue from 'vue'

export default Vue.extend({
  $_veeValidate: {
    value() {
      return this.value
    },
  },
  props: {
    value: String,
    placeholder:String,
    expandable: {
      type: Boolean,
      default: true
    }
  },
})
